// "1 place", "3 places"; capitalised to start a sentence.
export function placesText(count: number, capitalise = false) {
    const text = `${count} ${count === 1 ? 'place' : 'places'}`;
    return capitalise ? text[0].toUpperCase() + text.slice(1) : text;
}

// "File renamed.", and what happened to the places that use it.
export function renamedMessage(
    what: string,
    updated: number,
    notUpdated: number
) {
    let message = `${what} renamed.`;
    if (updated > 0) {
        message += ` Updated ${placesText(updated)} that use${
            updated === 1 ? 's' : ''
        } it.`;
    }
    if (notUpdated > 0) {
        message += ` ${placesText(
            notUpdated,
            true
        )} you can't change still use${
            notUpdated === 1 ? 's' : ''
        } the old name.`;
    }
    return message;
}
